// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-spinner-circles{display:inline-block}.v5-spinner-circles:after{content:\" \";display:block;width:100%;height:100%;border-radius:50%;border:.08rem solid #ff552e;box-sizing:border-box;border-color:#ff552e transparent #ff552e transparent;animation:v5-spinner-circles 1.2s linear infinite}@keyframes v5-spinner-circles{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
module.exports = exports;
